import { render, staticRenderFns } from "./SettingsP2PNotificationsExtra.vue?vue&type=template&id=2a721d1a&"
import script from "./SettingsP2PNotificationsExtra.vue?vue&type=script&lang=js&"
export * from "./SettingsP2PNotificationsExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports